import React, { memo } from "react"
import PropTypes from "prop-types"
import DeleteDeactivateModal from "../../../../../pages/guide/resources/equipment/modal/DeactivateDelete"
import { EQUIPMENT_DELETE_DEACTIVATE_MODES } from "../../../../../pages/guide/resources/equipment/constants"

const StaffModals = ({
  deactivateModalVisible,
  activateModalVisible,
  deleteModalVisible,
  selectedStaff,
  onDeactivateConfirm,
  onActivateConfirm,
  onDeleteConfirm,
  onCancel,
  t
}) => {
  if (!selectedStaff) return null

  return (
    <>
      {deactivateModalVisible && (
        <DeleteDeactivateModal
          visible={deactivateModalVisible}
          onCancel={onCancel}
          onOk={onDeactivateConfirm}
          title={t("staff.menu_items.deactivate") + " " + selectedStaff.name + "?"}
          subtitle={`Are you sure you want to deactivate ${selectedStaff.name}? They will be removed from all assigned experiences and upcoming bookings.`}
          okText={t("staff.menu_items.deactivate")}
          cancelText={t("common.cancel")}
          mode={EQUIPMENT_DELETE_DEACTIVATE_MODES.NO_EXPERIENCES}
          upcomingBookings={[]}
          assignedExperiences={[]}
        />
      )}

      {activateModalVisible && (
        <DeleteDeactivateModal
          visible={activateModalVisible}
          onCancel={onCancel}
          onOk={onActivateConfirm}
          title={t("staff.menu_items.activate") + " " + selectedStaff.name + "?"}
          subtitle={`Are you sure you want to activate ${selectedStaff.name}? They will become available for assignment to experiences and bookings.`}
          okText={t("staff.menu_items.activate")}
          cancelText={t("common.cancel")}
          mode={EQUIPMENT_DELETE_DEACTIVATE_MODES.NO_EXPERIENCES}
          upcomingBookings={[]}
          assignedExperiences={[]}
        />
      )}

      {deleteModalVisible && (
        <DeleteDeactivateModal
          visible={deleteModalVisible}
          onCancel={onCancel}
          onOk={onDeleteConfirm}
          title={t("staff.menu_items.delete") + " " + selectedStaff.name + "?"}
          subtitle={`Are you sure you want to permanently delete ${selectedStaff.name}? This action cannot be undone.`}
          okText={t("staff.menu_items.delete")}
          cancelText={t("common.cancel")}
          mode={EQUIPMENT_DELETE_DEACTIVATE_MODES.NO_EXPERIENCES}
          upcomingBookings={[]}
          assignedExperiences={[]}
        />
      )}
    </>
  )
}

StaffModals.propTypes = {
  deactivateModalVisible: PropTypes.bool.isRequired,
  activateModalVisible: PropTypes.bool.isRequired,
  deleteModalVisible: PropTypes.bool.isRequired,
  selectedStaff: PropTypes.object,
  onDeactivateConfirm: PropTypes.func.isRequired,
  onActivateConfirm: PropTypes.func.isRequired,
  onDeleteConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
}

export default memo(StaffModals)
